import request from "@/utils/request";

// 用户登录
export function loginToken(data) {
  return request({
    url: "/ums/user/login",
    method: "post",
    data: data
  });
}

// 退出登录
export function logout(data) {
  return request({
    url: "/ums/user/logout",
    method: "post",
    data: data
  });
}

// 获取验证码图片
export function getVerifyCode(data) {
  return request({
    url: "/ums/user/captcha",
    method: "get",
    timeout: 0,
    params: data
  });
}